export function centerFromUrl(state) {
    return state.centerFromUrl
}

export function categoriesFromUrl(state) {
    return state.categoriesFromUrl
}

export function poiDetailFromUrl(state) {
    return state.poiDetailFromUrl
}

export function waypointsFromUrl(state) {
    return state.waypointsFromUrl
}

export function interimStopsFromUrl(state) {
    return state.interimStopsFromUrl
}

export function transportModeFromUrl(state) {
    return state.transportModeFromUrl
}

export function specialContentFromUrl(state) {
    return state.specialContentFromUrl
}